import React from "react";

const MIGRATION_DEADLINE = new Date("2026-07-31T23:59:59");

export type MigrationCountdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  isPast: boolean;
};

const getCountdown = (): MigrationCountdown => {
  const diff = MIGRATION_DEADLINE.getTime() - Date.now();

  if (diff <= 0) {
    return { days: 0, hours: 0, minutes: 0, seconds: 0, isPast: true };
  }

  const totalSeconds = Math.floor(diff / 1000);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
    isPast: false,
  };
};

export const useMigrationCountdown = (): MigrationCountdown => {
  const [countdown, setCountdown] = React.useState<MigrationCountdown>(() =>
    getCountdown()
  );

  React.useEffect(() => {
    const tick = () => setCountdown(getCountdown());
    tick();
    const intervalId = window.setInterval(tick, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  return countdown;
};
